import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.TabsList>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.TabsList>
>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <TabsPrimitive.TabsList
      className={twMerge('flex gap-2', className)}
      {...rest}
      ref={ref}
    >
      {props.children}
    </TabsPrimitive.TabsList>
  );
});

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.TabsTrigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.TabsTrigger>
>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <TabsPrimitive.TabsTrigger
      className={twMerge(
        'py-2 px-6 rounded-[38px] data-[state=active]:bg-mobile-primary-500 data-[state=active]:text-white text-mobile-gray-600 bg-mobile-gray-50 flex items-center justify-center',
        className
      )}
      {...rest}
      ref={ref}
    >
      {props.children}
    </TabsPrimitive.TabsTrigger>
  );
});

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.TabsContent>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.TabsContent>
>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <TabsPrimitive.TabsContent
      className={twMerge('', className)}
      {...rest}
      ref={ref}
    >
      {props.children}
    </TabsPrimitive.TabsContent>
  );
});

Tabs.displayName = TabsPrimitive.Root.displayName;

TabsTrigger.displayName = TabsPrimitive.TabsTrigger.displayName;

TabsList.displayName = TabsPrimitive.TabsList.displayName;

TabsContent.displayName = TabsPrimitive.TabsContent.displayName;

export { Tabs, TabsContent, TabsList, TabsTrigger };
